<template class="ws-demo-exams__item">
  <ws-list-view-item-column>
    <section class="ws-demo-exams__item-content">
      <div class="columns">
        <div class="column is-10">
          <header class="ws-demo-exams__item-header">
            <ws-demo-exam-status :exam="exam" />
            <router-link :to="`/demo-exams/${exam.guid}`">
              <h2
                class="ws-demo-exams__item-title is-size-2 has-text-primary has-text-weight-bold"
              >
                <span>ID {{ exam.human_readable_id }} - </span>
                <span>{{ exam.name.display }}</span>
              </h2>
            </router-link>
            <p
              class="ws-demo-exams__item-competence"
              v-if="!!exam.accred_comps.competency"
            >
              <span
                class="has-text-grey"
                v-text="exam.accred_comps.competency.code"
              ></span
              >&nbsp;
              <span
                v-text="exam.accred_comps.competency.name.display"
              ></span
              >&nbsp;
              <span
                class="has-text-grey"
                v-text="exam.accred_comps.competency.name.second"
              ></span>
            </p>
            <p class="ws-demo-exams__item-de-center is-marginless">
              <ws-role-node :except="['front_50plus', 'front_mio']">
                <span>{{ $t("Статус ЦПДЭ: ") }}</span>
                <ws-accreditation
                  :accred_comps="exam.accred_comps"
                  :exam="exam"
                />
                <br />
              </ws-role-node>
              <span class="inline-flex">
                <span>{{ $t("ЦПДЭ: ") }}</span>
                <ws-icon
                  v-if="!exam.de_center.visible"
                  name="minus-circle"
                  width="12"
                  height="12"
                  class="minus-circle-ico"
                />
                <span class="has-text-weight-bold inline-flex">{{exam.de_center.name.display}}</span>
              </span>
              <ws-curator-list :curators="curators"/>
              <span
                v-if="
                  exam.de_center.address.region &&
                    exam.de_center.address.region.title.display
                "
              >
                {{
                  exam.de_center.address.region.title.display
                    .replace("г,", "г.")
                    .replace(", ,", ",")
                }},
              </span>
              <span
                v-if="
                  exam.de_center.address.locality &&
                    exam.de_center.address.locality.title.display
                "
              >
                {{
                  exam.de_center.address.locality.title.display
                    .replace("г,", "г.")
                    .replace(", ,", ",")
                }},
              </span>
              <span v-if="exam.de_center.address.address">
                {{
                  exam.de_center.address.address.display
                    .replace("ул,", "ул.")
                    .replace("д,", "д.")
                    .replace(", ,", ",")
                }}
              </span>
            </p>
          </header>

          <div class="ws-demo-exams__item-expert">
            <div class="columns is-multiline">
              <div
                class="column is-6"
                style="padding-bottom: 0"
                data-id="status-ge-column"
              >
                <span data-id="status-ge-title"
                  >{{ $t("Статус ГЭ") }}:
                </span>
                <span
                  data-id="expert-exam-status-none"
                  class="has-text-danger"
                  v-if="
                    exam.main_expert.expert_exam_status ===
                      expertStatus.none
                  "
                >
                  <b>{{
                    currentRole === "front_mio" ||
                    currentRole === "front_50plus"
                      ? $t("Не назначен")
                      : $t("Не запрошен")
                  }}</b>
                </span>
                <span
                  data-id="expert-exam-status-none"
                  class="has-text-danger"
                  v-if="
                    exam.main_expert.expert_exam_status ===
                      expertStatus.rejected
                  "
                >
                  <b>{{ $t("Главный эксперт отклонен") }}</b>
                </span>
                <span
                  v-if="
                    exam.main_expert.expert_exam_status ===
                      expertStatus.requested
                  "
                >
                  <span
                    class="has-text-warning"
                    v-if="exam.main_expert.guid !== nullGuid"
                  >
                    <b
                      >{{ $t("Запрошен, не утвержден") }}
                      <ws-time-formatter
                        :date="getMainExpertStatusUpdateDate(exam)"
                      />
                    </b>
                  </span>
                  <span class="has-text-success" v-else>
                    <b>{{ $t("Без указания кандидатуры") }}</b>
                  </span>
                </span>
                <span
                  class="has-text-success"
                  v-if="
                    exam.main_expert.expert_exam_status ===
                      expertStatus.accepted
                  "
                >
                  <b
                    >{{
                      currentRole === "front_mio" ||
                      currentRole === "front_50plus"
                        ? $t("Назначен")
                        : $t("Согласован")
                    }}
                    <ws-time-formatter
                      :date="getMainExpertStatusUpdateDate(exam)"
                    />
                  </b>
                  <span v-if="isRemoteMainExpert(exam)">
                    {{ $t("Дистанционный (удаленный) формат") }}
                  </span>
                </span>
                <b-button
                  size="ws-button button is-small is-text ws-demo-exams__show-history"
                  @click="showMainExpertHistory(exam)"
                >
                  <ws-icon
                    class="ws-button__icon"
                    name="clock"
                    color="#1c3b8d"
                    :fill="true"
                    width="16"
                    height="16"
                  />
                </b-button>
              </div>
              <div
                class="column is-7"
                style="padding-top: 0"
                v-if="exam.main_expert.guid !== nullGuid"
              >
                <div class="columns" style="margin-bottom: 0;">
                  <div
                    class="column is-narrow"
                    style="padding-right: 0; padding-bottom: 0"
                  >
                    <span v-text="$t('ГЭ')"></span>:&nbsp;
                  </div>
                  <div
                    class="column"
                    style="padding-left: 7px; padding-bottom: 0"
                    v-if="
                      exam.main_expert.guid !== nullGuid &&
                        exam.main_expert.user_info
                    "
                  >
                    <strong>
                      <span
                        v-text="
                          exam.main_expert.user_info.last.display
                        "
                      ></span>
                      <span>&nbsp;</span>
                      <span
                        v-text="
                          exam.main_expert.user_info.first.display
                        "
                      ></span>
                      <span>&nbsp;</span>
                      <span
                        v-text="
                          exam.main_expert.user_info.middle.display
                        "
                      ></span>
                    </strong>
                    <span
                      class="has-text-grey"
                      v-if="
                        exam.main_expert &&
                          exam.main_expert.region &&
                          exam.main_expert.region.title.display
                      "
                    >
                      ({{
                        exam.main_expert.region.title.display
                      }})</span
                    >
                    <br />
                    <span
                      class="has-text-black has-text-weight-normal"
                      v-if="getPhoneNumber(exam.main_expert)"
                      >{{
                        getPhoneNumber(exam.main_expert)
                      }},&nbsp;</span
                    ><span
                      class="has-text-primary has-text-weight-normal"
                      >{{ exam.main_expert.user_info.email }}</span
                    >
                  </div>
                </div>
                <ws-demo-exams-certificate-view expertType="mainExpert" :exam_day_cm1="exam.day_cm1" :expert="exam.main_expert" />
              </div>
            </div>
          </div>
        </div>
        <div class="column is-2">
          <dl class="ws-demo-exams-meta">
            <dt
              class="has-text-grey is-size-5"
              v-text="$t('День ПД')"
            ></dt>
            <dd
              class="is-size-4 has-text-black"
              v-if="exam.day_cm1"
            >
              <ws-time-formatter
                :date="exam.day_cm1"
                format="LL"
              />
            </dd>
          </dl>
          <dl class="ws-demo-exams-meta">
            <dt
              class="has-text-grey is-size-5"
              v-text="$t('Дата начала')"
            ></dt>
            <dd
              class="is-size-4 has-text-black"
              v-if="exam.started_at"
            >
              <ws-time-formatter
                :date="exam.started_at"
                format="LL"
              />
            </dd>
          </dl>
          <dl class="ws-demo-exams-meta">
            <dt
              class="has-text-grey is-size-5"
              v-text="$t('Дата окончания')"
            ></dt>
            <dd
              class="is-size-4 has-text-black"
              v-if="exam.ended_at"
            >
              <ws-time-formatter
                :date="exam.ended_at"
                format="LL"
              />
            </dd>
          </dl>
        </div>
      </div>
    </section>

    <footer class="ws-demo-exams__item-footer">
      <div class="columns is-vcentered">
        <div class="column is-10">
          <div class="buttons">
            <ws-permission-node
              :resources="['services/de/mainexpert']"
              :actions="['read', 'create', 'update']"
              effect="display"
            >
              <button
                class="ws-button button is-text"
                @click="requestMainExpertForm(exam)"
                :disabled="
                  !isCanRequestMainExpert(exam) ||
                    exam.status === 'complete_main_expert' ||
                    getIsBlockedStatus(exam.status)
                "
              >
                <ws-icon
                  class="ws-button__icon"
                  name="user-fav"
                  :title="
                    currentRole === 'front_mio' ||
                    currentRole === 'front_50plus'
                      ? $t('Назначить главного эксперта')
                      : $t('Заявка на главного эксперта')
                  "
                  color="#1c3b8d"
                  width="20"
                  height="20"
                />
                <span
                  class="ws-button__text has-text-primary"
                  v-text="
                    currentRole === 'front_mio' ||
                    currentRole === 'front_50plus'
                      ? $t('Назначить главного эксперта')
                      : $t('Заявка на главного эксперта')
                  "
                ></span>
              </button>
            </ws-permission-node>
            <ws-permission-node
              :resources="['services/de/technicalexperts']"
              :actions="['read', 'create', 'update']"
              effect="display"
            >
              <button
                class="ws-button button is-text ws-button-appendix-right"
                :disabled="
                  currentRole === 'front_le' ||
                  currentRole === 'front_tech_expert' ||
                  currentRole === 'front_auditor' ||
                    (currentRole !== 'front_dep' &&
                      currentRole !== 'front_education_ministry' &&
                      currentRole !== 'front_admin' &&
                      currentRole !== 'front_me' &&
                      (exam.status === 'confirmed_auth_org' ||
                        exam.status === 'approved_main_expert')) ||
                    exam.status === 'complete_main_expert' ||
                    getIsBlockedStatus(exam.status)
                "
                @click="requestTechnicalExpertForm(exam)"
              >
                <ws-icon
                  class="ws-button__icon"
                  name="member"
                  :title="$t('Технические эксперты')"
                  color="#1c3b8d"
                  width="20"
                  height="20"
                />
                <span
                  class="ws-button__text has-text-primary"
                  v-text="$t('Технические эксперты')"
                ></span>
              </button>
              <b-dropdown
                class="ws-participants__dropdown ws-button is-text button ws-appendix-right"
                v-if="
                  exam.technical_experts &&
                    exam.technical_experts.length
                "
                aria-role="list"
                position="is-top-left"
              >
                <span class="is-hoverable" slot="trigger" role="button">
                  <span class="has-text-primary">
                    ({{ exam.technical_experts.length }})</span
                  >
                </span>
                <b-dropdown-item
                  custom
                  v-for="expert in exam.technical_experts"
                  :value="expert"
                  :key="expert.guid"
                  aria-role="listitem"
                >
                  <div class="media" v-if="expert.user_info">
                    <div class="media-left">
                      <figure class="image is-48x48">
                        <ws-avatar
                          :id="expert.guid"
                          :name="
                            `${expert.user_info.first.display} ${
                              expert.user_info.last.display
                            }`
                          "
                          sizeType="Small"
                          :size="48"
                        />
                      </figure>
                    </div>
                    <div class="media-content">
                      <strong>{{
                        expert.user_info.last.display
                      }}</strong
                      ><br />
                      <span>{{ expert.user_info.first.display }}</span
                      ><span>&nbsp;</span>
                      <span>{{ expert.user_info.middle.display }}</span
                      ><br />
                      <span>{{ expert.user_info.email }}</span
                      ><br />
                      <span>{{
                        getTechnicalExpertPhoneNumbers(expert)
                      }}</span>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
              <span
                v-else
                class="ws-button button is-text ws-appendix-right"
              >
                <span
                  class="has-text-danger"
                  v-text="$t(' (0)')"
                ></span>
              </span>
            </ws-permission-node>
            <ws-permission-node
              :resources="['services/de/experts']"
              :actions="['create', 'read', 'update']"
              effect="display"
            >
              <button
                class="ws-button button is-text ws-button-appendix-right"
                :disabled="
                  disabledExpertsBtn(exam)
                "
                @click="requestExpertForm(exam)"
              >
                <ws-icon
                  class="ws-button__icon"
                  name="member"
                  :title="
                    currentRole === 'front_me'
                      ? $t('Управление экспертами')
                      : $t('Заявка на экспертов')
                  "
                  color="#1c3b8d"
                  width="20"
                  height="20"
                />
                <span
                  class="ws-button__text has-text-primary"
                  v-text="
                    currentRole === 'front_me'
                      ? $t('Управление экспертами')
                      : $t('Заявка на экспертов')
                  "
                ></span>
              </button>
              <b-dropdown
                class="ws-participants__dropdown ws-button is-text button ws-appendix-right"
                v-if="exam.experts && exam.experts.length"
                aria-role="list"
                position="is-top-left"
              >
                <span class="is-hoverable" slot="trigger" role="button">
                  <span class="has-text-primary">
                    ({{ exam.experts.length }})</span
                  >
                </span>
                <b-dropdown-item
                  custom
                  v-for="expert in exam.experts"
                  :value="expert"
                  :key="expert.guid"
                  aria-role="listitem"
                >
                  <div class="media">
                    <div class="media-left">
                      <figure class="image is-48x48">
                        <ws-avatar
                          v-if="expert.user_info"
                          :id="expert.user_info.guid"
                          :name="
                            `${expert.user_info.first.display} ${
                              expert.user_info.last.display
                            }`
                          "
                          sizeType="Small"
                          :size="48"
                        />
                      </figure>
                    </div>
                    <div class="media-content" v-if="expert.user_info">
                      <strong>{{
                        expert.user_info.last.display
                      }}</strong
                      ><br />
                      <span>{{ expert.user_info.first.display }}</span
                      ><span>&nbsp;</span>
                      <span>{{ expert.user_info.middle.display }}</span>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
              <span
                v-else
                class="ws-button button is-text ws-appendix-right"
              >
                <span
                  class="has-text-danger"
                  v-text="$t(' (0)')"
                ></span>
              </span>
            </ws-permission-node>
            <ws-role-node :only="['front_dep']">
              <button
                class="ws-button button is-text"
                :class="{ 'is-loading': isStatusUpdating }"
                v-if="
                  exam.status ===
                    constants.exam_status.CONFIRMED_AUTH_ORG ||
                    exam.status ===
                      constants.exam_status.CONFIRMED_AUTH_ORG_BLOCKED
                "
                :disabled="getIsBlockedStatus(exam.status)"
                @click="
                  updateExamStatus(exam, 'revision_de_department')
                "
              >
                <ws-icon
                  class="ws-button__icon"
                  name="close"
                  color="#1c3b8d"
                  width="20"
                  height="20"
                />
                <span
                  class="ws-button__text has-text-primary"
                  v-text="$t('Вернуть на доработку')"
                ></span>
              </button>
            </ws-role-node>
            <ws-demo-exams-approve
              :exam="exam"
              :accred_comps="exam.accred_comps"
            ></ws-demo-exams-approve>
          </div>
        </div>
        <WsFooterInfoItemList :exam="exam" />
      </div>
    </footer>
  </ws-list-view-item-column>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

import WsAccreditation from '@/components/de/de-center/WsAccredidation'
import WsCuratorList from '@/components/de/demo-exams/WsCuratorList.vue'
import WsDemoExamsApprove from '@/components/de/demo-exams/WsDemoExamsApprove'
import WsFooterInfoItemList from '@/components/de/demo-exams/WsFooterInfoItemList.vue'

import WsDemoExamsCertificateView from './WsDemoExamsCertificateView.vue'
import WsDemoExamStatus from './WsDemoExamStatus.vue'
import getPhoneNumber from '@/utils/getPhoneNumber'
import isBlockedExam from '@/mixins/is-blocked-exam.mixin'
// import examsListMixin from '@/mixins/exams-list.mixin'
import { constants } from '@/services/constants.service'
import { get } from 'lodash-es'
import WsExamExpertLog from '@/components/de/demo-exams/modals/WsExamExpertLog'
import WsMainExpertManagement from '@/components/de/modals/WsMainExpertManagement'
import WsTechnicalExpertsManagement from '@/components/de/modals/WsTechnicalExpertsManagement'
import WsExpertsManagement from '@/components/de/modals/WsExpertsManagement'

import expertStatus from './data/expertStatusEnum'

const nullGuid = '00000000-0000-0000-0000-000000000000'
export default {
  name: 'WsDemoExamsCardList',
  mixins: [
    isBlockedExam],
  components: {
    WsFooterInfoItemList,
    WsAccreditation,
    WsDemoExamsApprove,
    WsDemoExamStatus,
    WsDemoExamsCertificateView,
    WsCuratorList
  },
  props: { curators: Array, curatorsObject: Object, exam: Object },

  data () {
    return {
      // ready: 0,
      // flags: '',
      isStatusUpdating: false,
      constants,
      expertStatus,
      nullGuid
      // curators: []
    }
  },

  computed: {
    ...mapState('authentication', ['currentRole']),
    ...mapGetters('authentication', ['getUserGuid'])
  },

  methods: {
    ...mapMutations({
      updateExamItem: 'exams/updateItem',
      updateMyExamItem: 'my-exams/updateItem'
    }),

    getMainExpertStatusUpdateDate (exam) {
      return exam.main_expert.changed_at
    },

    isRemoteMainExpert (exam) {
      return exam.flags.indexOf('main_expert_is_remote') > -1
    },

    isCanRequestMainExpert (exam) {
      if (
        this.currentRole === 'front_dep' ||
        this.currentRole === 'front_admin' ||
        this.currentRole === 'front_education_ministry' ||
        this.currentRole === 'front_curator'
      ) {
        return true
      } else if (
        this.currentRole === 'front_mc' &&
        exam.status === 'confirmed_auth_org'
      ) {
        return true
      } else if (this.currentRole === 'front_auditor') {
        return false
      } else {
        return (
          exam.status !== 'confirmed_auth_org' &&
          exam.status !== 'approved_main_expert'
        )
      }
    },

    disabledExpertsBtn () {
      const statuses = ['confirmed_auth_org', 'agreed_de_department']
      const roles = ['front_dep', 'front_education_ministry', 'front_admin', 'front_me', 'front_curator']

      const { status } = this.exam

      if (status !== 'complete_main_expert' || this.getIsBlockedStatus(status)) {
        if (this.currentRole === 'front_rcc' || this.currentRole === 'front_curator') {
          return false
        }
      }

      if (status === 'new' && (this.currentRole === 'front_le' || this.currentRole === 'front_tech_expert')) {
        return true
      } else if (!roles.includes(this.currentRole) && !statuses.includes(status)) {
        return true
      } else if (this.currentRole === 'front_auditor' || status === 'complete_main_expert' || this.getIsBlockedStatus(status)) {
        return true
      }

      return false
    },

    getTechnicalExpertPhoneNumbers (expert) {
      const phoneNumbers = get(
        expert,
        'user_info.profile.contacts.communication.phone'
      )
      if (phoneNumbers && phoneNumbers.length) {
        return phoneNumbers.reduce((str, number, index) => {
          if (index) {
            str += ' ,'
          }
          str += number.value
          return str
        }, '')
      }
      return null
    },

    showMainExpertHistory (exam) {
      this.$buefy.modal.open({
        parent: this,
        component: WsExamExpertLog,
        scroll: 'clip',
        hasModalCard: true,
        canCancel: true,
        width: '90%',
        props: {
          examGuid: exam.guid
        }
      })
    },

    requestMainExpertForm (exam) {
      this.$buefy.modal.open({
        parent: this,
        component: WsMainExpertManagement,
        hasModalCard: true,
        scroll: 'clip',
        props: { exam, experts: exam.experts, isMyDeCenter: this.isMyDeCenter(exam) },
        canCancel: false,
        events: {
          close: event => {
            const docs = {
              attestations: exam.main_expert.attestations || [],
              certificates: exam.main_expert.certificates || []
            }
            this.updateExamItem({ ...event, main_expert: { ...event.main_expert, ...docs } })
          },
          update: event => {
            const docs = {
              attestations: exam.main_expert.attestations || [],
              certificates: exam.main_expert.certificates || []
            }
            this.updateExamItem({ ...event, main_expert: { ...event.main_expert, ...docs } })
          }
        }
      })
    },

    requestTechnicalExpertForm (exam) {
      this.$buefy.modal.open({
        parent: this,
        component: WsTechnicalExpertsManagement,
        hasModalCard: true,
        props: { exam, isMyDeCenter: this.isMyDeCenter(exam) },
        canCancel: false,
        scroll: 'clip',
        events: {
          close: event => {
            const docs = {
              attestations: exam.main_expert.attestations || [],
              certificates: exam.main_expert.certificates || []
            }
            this.updateExamItem({ ...event, main_expert: { ...event.main_expert, ...docs } })
          },
          update: event => {
            this.updateExamItem({ ...event })
          }
        }
      })
    },

    requestExpertForm (exam) {
      this.$buefy.modal.open({
        parent: this,
        component: WsExpertsManagement,
        hasModalCard: true,
        scroll: 'clip',
        props: { exam, isMyDeCenter: this.isMyDeCenter(exam) },
        canCancel: false,
        events: {
          close: event => {
            const docs = {
              attestations: exam.main_expert.attestations || [],
              certificates: exam.main_expert.certificates || []
            }
            if (this.isMy) {
              this.updateMyExamItem({ ...event, main_expert: { ...event.main_expert, ...docs } })
            } else {
              this.updateExamItem({ ...event, main_expert: { ...event.main_expert, ...docs } })
            }
          },
          update: event => {
            this.updateExamItem({ ...event })
          }
        }
      })
    },

    async updateExamStatus (exam, status) {
      this.isStatusUpdating = true
      await this.update([exam.guid, [], `/status/${status}`])
      this.isStatusUpdating = false
    },

    isMyDeCenter (exam) {
      const curatorsObject = { ...this.curatorsObject }
      const curatorsKeys = Object.keys(curatorsObject)

      if (this.currentRole !== 'front_curator') return true

      const guid = (exam.shifts[0] &&
        exam.shifts[0].groups[0] &&
        exam.shifts[0].groups[0].university &&
        exam.shifts[0].groups[0].university) ? exam.shifts[0].groups[0].university.guid : exam.de_center.parent.guid

      const deCenterCurators = curatorsKeys.includes(guid) ? curatorsObject[guid] : null

      if (deCenterCurators === null) return false
      const hasCurators = Object.keys(deCenterCurators).length

      if (!hasCurators) return false
      const isCurator = deCenterCurators.findIndex(item => item.guid === this.getUserGuid) > -1

      return this.currentRole === 'front_curator' ? isCurator : true
    },

    getPhoneNumber
  }
}
</script>
